import React, { useCallback, useContext } from 'react';
import useTranslations from '../../../hooks/useTranslations';
import { FormContext, useField } from '../FormContext';
import ConfirmationBoxView from '../view/ConfirmationBoxView';

const ConfirmationBoxEngine = ({
  internalId,
  value,
  setValue,
  required,
  readOnly,
  options,
  annotations,
  ...fieldProps // for future development, know whe have this
}) => {
  const { validateField, onFormBuilderDefaultValueSaved = () => {} } =
    useContext(FormContext);
  const t = useTranslations();

  const onChecked = event => {
    const { checked } = event.target;
    let newValue = checked ? checked + '' : null;
    setValue(newValue);
    onFormBuilderDefaultValueSaved(newValue);
  };

  const validator = useCallback(
    value => {
      value = value ? value : false;
      let error = '';

      if (required && !!!value) {
        error = t('forms.fields.error.required');
      }

      return error;
    },
    [required]
  );

  useField(internalId, validator);

  let tooltip = '';
  if (annotations && annotations.tooltips && options[0]) {
    tooltip = annotations.tooltips[options[0]] || '';
  }

  const viewProps = {
    internalId,
    onChecked,
    readOnly,
    value: value === 'true',
    checkboxText: options[0] || '',
    required,
    tooltip
  };

  return <ConfirmationBoxView {...viewProps} />;
};

export default ConfirmationBoxEngine;
